module.exports = __webpack_public_path__ + "img/zhujichangpeitao.0534046b.png";